/**
 * Created by jonas on 2020-11-04.
 */
import {gsap} from "gsap";
import {MultiLayerBitmapFont} from "./MultiLayerBitmapFont";

export class WinWayDisplay extends PIXI.Container {
    private _view:PIXI.Container = new PIXI.Container();
    set singeLine(value:boolean) {
        this._singeLine = value;
        this.updateStyle();
        this.updateLayout();
    }
    private _multiNumber:MultiLayerBitmapFont;
    private _multiText:MultiLayerBitmapFont;
    private _singeLine:boolean;

    constructor(singleLine: boolean = false,setSize:number=110) {
        super();
        this.init(setSize);
        this.singeLine = singleLine;
    }

    private init(setSize:number) {
        const size = setSize;
        const multiNumber = new MultiLayerBitmapFont("0", [
            {
                fontName:"WinWaysBottom",
                fontSize:size
            },
            {
                fontName:"WinWaysTop",
                fontSize:size
            }
        ]);

        const multiText = new MultiLayerBitmapFont(";", [
            {
                fontName:"WinWaysBottom",
                size:Math.floor(size * 0.8)
            },
            {
                fontName:"WinWaysTop",
                size:Math.floor(size * 0.8)
            }
        ]);



        this._multiNumber = multiNumber;
        this._multiText = multiText;
        this._view.addChild(this._multiNumber, this._multiText);
        this.addChild(this._view);

    }

    public setWays(ways:number) {
        this._multiNumber.text = "" + ways;
        if (ways > 1){
            this._multiText.text = ";+";
        }
        else {
            this._multiText.text = ";";
        }

        this.updateLayout();
    }

    public getShowAnimation(ways:number, duration:number):gsap.core.Timeline | undefined {
        if (ways <= 0) {
            this.alpha = 0;
            return;
        }


        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.alpha = 0;
            this.setWays(ways);
        });

        tl.add(gsap.to(this, {duration:duration,alpha:1, ease:"none"}));


        return tl;

    }


    private updateStyle() {
        if (this._singeLine){
            this._multiNumber.setFontSize(70);
            this._multiText.setFontSize(70);
        }
        else {
            this._multiNumber.setFontSize(110);
            this._multiText.setFontSize(88);
        }

    }
    private updateLayout() {
        if (this._singeLine){
            this._multiNumber.anchor.set(0, 0.5);
            this._multiText.anchor.set(0, 0.5);

            this._multiNumber.position.set(0,0);
            this._multiText.position.set(this._multiNumber.width-10, -12);

            this._view.pivot.set(this._view.width * 0.5,0);
        }
        else {

            this._multiNumber.anchor.set(0.5, 0.5);
            this._multiNumber.position.set(0,0);

            this._multiText.anchor.set(0.5, 0.5);
            this._multiText.position.set(this._multiNumber.position.x, this._multiNumber.position.y + 32);
            this._view.pivot.set(0,0);
        }
    }
}